export enum DashboardTabType {
  LEARNING_HUB = 'goals',
  INSIGHTS = 'channels',
  GET_STARTED = 'get-started',
}
